import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {catchError, filter, firstValueFrom, map, of} from "rxjs";
import {EventDataService} from "./event-data.service";
import {UpdateService} from "./update.service";
import {KEY_REGEX} from "./utils";

export const shortUrlResolver: ResolveFn<void> = async function(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const potentialRegionKey = route.url[0]?.path;
  const potentialEventKey = route.url[1]?.path;

  const router = inject(Router);
  const updateService = inject(UpdateService);

  if(potentialRegionKey && KEY_REGEX.test(potentialRegionKey)) {
    const eventDataService = inject(EventDataService);
    if(potentialEventKey && KEY_REGEX.test(potentialEventKey)) {
      const name = await firstValueFrom(eventDataService.getEventName(potentialRegionKey, potentialEventKey));

      if(name) {
        return new RedirectCommand(router.createUrlTree(['/region', potentialRegionKey, 'event', potentialEventKey, ...route.url.slice(2).map(u => u.path)], {queryParams: route.queryParams}));
      }
    } else {
      const name = await firstValueFrom(eventDataService.getRegionName(potentialRegionKey));
      if(name) {
        return  new RedirectCommand(router.createUrlTree(['/region', potentialRegionKey], {queryParams: route.queryParams}));
      }
    }
  }

  return firstValueFrom(updateService.checkForUpdate().pipe(
    catchError(() => of(false)),
    filter(updateAvailable => !updateAvailable), // if an update is available, block forever so the update service can trigger a browser refresh.
    map(() => new RedirectCommand(router.parseUrl('/error?message=' + `Page not found` + `&details=${state.url}`))),
  ));
}
